<template>
  <v-form @submit.prevent="submitReferralCode" class="d-flex justify-center flex-column" :class="!$vuetify.breakpoint.smAndUp && 'w-100'" ref="referralForm">
    <v-card-text class="d-flex flex-column align-center" :class="!$vuetify.breakpoint.lgAndUp && 'px-0 mx-0'">
      <v-text-field dense v-model="form.referralCode" :label="$t('label.referralCode')" class="stretch-append text-field-styling w-100" :error-messages="referralCodeErrors" outlined rounded />
    </v-card-text>

    <v-card-actions class="d-flex flex-column align-stretch px-4">
      <v-btn color="primary" class="mb-5 d-block rounded-pill green-gradient-right text-capitalize override-disabled-styles" type="submit" :loading="loading">{{ $t('next') }}</v-btn>
      <v-btn class="align-self-center primary--text" icon fab @click="$emit('prev-step')"><LeftArrow /></v-btn>
    </v-card-actions>
  </v-form>
</template>

<script>
import { mapMutations, mapActions } from 'vuex'

import LeftArrow from '@/assets/icons/left-arrow-circle.svg'

export default {
  components: { LeftArrow },

  data: () => ({
    loading: false,
    form: {
      referralCode: ''
    },
    submissionErrors: {
      referralCode: ''
    }
  }),

  computed: {
    referralCodeErrors() {
      const errors = []
      this.submissionErrors.referralCode && errors.push(this.submissionErrors.referralCode)
      return errors
    }
  },

  methods: {
    ...mapActions('auth', ['register']),
    ...mapActions('common', ['verifyReferralCode']),
    ...mapMutations('auth', ['storeReferralForm']),
    async submitReferralCode() {
      this.loading = true

      try {
        if (this.form.referralCode) {
          await this.verifyReferralCode(this.form).then((res) => {
            if (!res.is_valid) {
              throw {
                type: 'referralCode',
                message: 'This is not a valid referral code.'
              }
            } else {
              this.storeReferralForm(this.form)
              this.submissionErrors.referralCode = ''
            }
          })
        }
        this.$emit('next-step')
      } catch (error) {
        this.submissionErrors[error.type] = error.message
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
